export const productCategories = [
  {
    id: 1,
    name: 'SOCKET HEAD CAP SCREW',
    description: 'High-strength screws with a cylindrical head and hexagonal drive.',
    image: '/products/shcs-new.png',
    mainImage: '/products/prd-1.png',
    technicalImage: '/products/prd-t.png',
    specifications: [
      'As per DIN912 & ISO4762 for Metric Series and BS2470 for Inch Series',
      'Range: Metric Series: M3 to M48',
      'Range: Inch Series: 1/8" to 1"',
      'M3 to M27 by Cold Forging Process',
      'M27 and Above by Hot Forging Process',
      'Controlled hex socket for maximum wrenching strength',
      'Uniform socket depth for accurate key fit & higher torque',
      'Knurled head for finger grip fast assembly',
      'Smooth fillet radius to withstand head soundness',
      'Formed threads with improved root radius provide greater strength to threads',
      'Uniform & uninterrupted grain flow for greater strength',
      'Controlled mechanical properties for higher strength'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Metric Series – DIN912 & ISO4762 | Inch Series – BS2470' },
          { type: 'text', value: 'Grade: 12.9 (Standard Grade) | 8.8/10.9 (As per order)' },
          { type: 'text', value: 'Metric Series – Diameter: M3 to M48 | Length: 3mm – 400mm' },
          { type: 'text', value: 'Inch Series – Diameter: 1/8" to 1" | Length: 3/8" to 12"' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Structure: 12.9 - With Knurling | 8.8/10.9 – Without Knurling.' },
          { type: 'text', value: 'Forging: M3 to M27 by Cold Forging Process | M27 and Above by Hot Forging Process.' },
          { type: 'text', value: 'Raw Material Used: 12.9 - 4135/4140 | 8.8/10.9 - 10B21/15B25.' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'Controlled Hex Socket for maximum wrenching strength.' },
          { type: 'text', value: 'Uniform Socket depth for accurate key fit & higher torque.' },
          { type: 'text', value: 'Knurled head for finger grip fast assembly.' },
          { type: 'text', value: 'Smooth fillet radius to withstand head soundness.' },
          { type: 'text', value: 'Formed threads with improved root radius provide greater strength to threads.' }
        ]
      }
    ]
  },
  {
    id: 2,
    name: 'SOCKET COUNTER SUNK HEAD (CSK)',
    description: 'Screws that sit flush with the surface, featuring a conical head.',
    image: '/products/30.jpg',
    mainImage: '/products/prd2.png',
    technicalImage: '/products/prd-t2.png',
    specifications: [
      'Perfect angle under the head ensures flush seating',
      'Controlled hex socket for maximum wrenching strength',
      'Smooth fillet radius to withstand head soundness',
      'Hi-grade alloy steel for good strength & wear resistance',
      'Uniform socket depth for accurate key fit & higher torque',
      'Closely controlled threads under radius root process proper fit & depth assemblies',
      'Controlled mechanical properties for higher strength',
      'Controlled concentricity in totality to create a high resistance to lateral movements'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Metric Series – DIN7991 & ISO10642 | Inch Series – BS2470' },
          { type: 'text', value: 'Grade: 12.9 (Standard Grade) | 8.8/10.9 (As per order)' },
          { type: 'text', value: 'Metric Series – Diameter: M3 to M24 | Length: 6mm – 200mm' },
          { type: 'text', value: 'Inch Series – Diameter: 1/4" to 5/8" | Length: 1/2" to 6"' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Structure: Flat tapered head, fully threaded.' },
          { type: 'text', value: 'Forging: M3 to M27 by Cold Forging Process | M27 and Above by Hot Forging Process' },
          { type: 'text', value: 'Raw Material Used: 12.9 - 4135/4140 | 8.8/10.9 - 10B21/15B25' },
          { type: 'text', value: 'CSK is always fully threaded.' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'Perfect angle under the head ensures flush seating.' },
          { type: 'text', value: 'Controlled Hex Socket for maximum wrenching strength.' },
          { type: 'text', value: 'Smooth fillet radius to withstand head soundness.' },
          { type: 'text', value: 'High-grade alloy steel for good strength & wear resistance.' },
          { type: 'text', value: 'Uniform Socket depth for accurate key fit & higher torque.' },
          { type: 'text', value: 'Closely controlled threads under radius root process proper fit & depth assemblies.' },
          { type: 'text', value: 'Controlled mechanical properties for higher strength.' },
          { type: 'text', value: 'Controlled concentricity in totality to create a high resistance to lateral movements.' }
        ]
      }
    ]
  },
  {
    id: 3,
    name: 'SOCKET SET SCREW',
    description: 'Headless screws fully threaded, used for fastening one object within another.',
    image: '/products/28.jpg',
    mainImage: '/products/prd-21.png',
    technicalImage: '/products/ss22.jpg',
    specifications: [
      'A set screw is a type of screw generally used to secure an object within or against another object',
      'The set screw passes through a threaded hole in the outer object and is tightened against the inner object',
      'Set screws do not come in one shape or size - there are several different variations with different strengths',
      'Different-shaped tips have unique properties that engineers can take advantage of',
      'Cone point type for proper nesting of the screw',
      'Flat point for pressing perfectly flat against the surface',
      'Available in various point types for different applications'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Metric Series – DIN916 & ISO4029 | Inch Series – BS2470' },
          { type: 'text', value: 'Grade: 14.9 (Standard Grade) | 8.8/10.9/12.9 (As per order)' },
          { type: 'text', value: 'Metric Series – Diameter: M3 – M20 | Length: 3mm – 80mm' },
          { type: 'text', value: 'Inch Series – Diameter: 3/16" to 3/4" | Length: 3/16" to 3"' },
          { type: 'text', value: 'Forging: M3 to M20 by Cold Forging Process' },
          { type: 'text', value: 'Raw Material Used: 14.9/12.9 - 4135/4140 | 8.8/10.9 - 10B21/15B25' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Other Variants: Manufactured as per order/Custom-made items' },
          { type: 'text', value: 'FLAT POINT – DIN 913, ISO 4026' },
          { type: 'text', value: 'CONE POINT – DIN 914, ISO 4027' },
          { type: 'text', value: 'DOG / HALF DOG POINT – DIN 915, ISO 4028' },
          { type: 'text', value: 'CUP POINT – DIN 916, ISO 4029' },
          { type: 'text', value: 'Cup Point: Strong holding power through a concave tip that slightly penetrates the mating surface.' },
          { type: 'text', value: 'Cone Point: Proper nesting of the screw.' },
          { type: 'text', value: 'Flat Point: Presses perfectly flat against the surface.' },
          { type: 'text', value: 'Dog Point: Fits into a mating hole or slot with a short pin-like end.' },
          { type: 'text', value: 'Half Dog Point: Similar to Dog Point but shorter and shallower.' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'A Socket Set Screw (SSS) or Grub Screw is used to secure an object within or against another object.' },
          { type: 'text', value: 'The Socket Set Screw passes through a threaded hole in the outer object and is tightened against the inner object.' },
          { type: 'text', value: 'Socket Set Screws are available in several different variations with different strengths.' },
          { type: 'text', value: 'Different-shaped tips have unique properties that engineers can take advantage of.' }
        ]
      }
    ]
  },
  {
    id: 4,
    name: 'BUTTON HEAD CAP SCREW',
    description: 'Screws with a wide, low-profile cylindrical head and hexagonal drive.',
    image: '/products/bhcs.jpg',
    mainImage: '/products/btn.jpg',
    technicalImage: '/products/prd-t4.png',
    specifications: [
      'Controlled hex socket for maximum wrenching strength',
      'Uniform socket depth for accurate key fit & higher torque',
      'Smooth fillet radius to withstand head soundness',
      'Formed threads with improved root radius provide greater strength to threads',
      'Uniform & uninterrupted grain flow for greater strength',
      'Controlled mechanical properties for higher strength',
      'High grade alloy steel for good strength & wear resistance',
      'Smooth radiuses head ensures easy handling to the user',
      'Controlled concentricity in totality to create a high resistance to lateral movements'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Metric Series – DIN9427 & ISO7380 | Inch Series – BS2470' },
          { type: 'text', value: 'Grade: 12.9 (Standard Grade) | 8.8/10.9 (As per order)' },
          { type: 'text', value: 'Metric Series – Diameter: M3 to M12 | Length: 5mm – 50mm' },
          { type: 'text', value: 'Inch Series – Diameter: 1/4" to 5/8" | Length: 1/2" to 6"' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Structure: Dome-shaped head, fully threaded.' },
          { type: 'text', value: 'Forging: M3 to M12 by Cold Forging.' },
          { type: 'text', value: 'Raw Material Used: 12.9 - 4135/4140 | 8.8/10.9 - 10B21/15B25.' },
          { type: 'text', value: 'BHCS is always fully threaded.' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'Controlled Hex Socket for maximum wrenching strength.' },
          { type: 'text', value: 'Uniform Socket depth for accurate key fit & higher torque.' },
          { type: 'text', value: 'Smooth fillet radius to withstand head soundness.' },
          { type: 'text', value: 'Formed threads with improved root radius provide greater strength to threads.' },
          { type: 'text', value: 'Uniform & uninterrupted grain flow for greater strength.' },
          { type: 'text', value: 'Controlled mechanical properties for higher strength.' },
          { type: 'text', value: 'High grade alloy steel for good strength & wear resistance.' },
          { type: 'text', value: 'Smooth radiuses ensure easy handling to the user.' },
          { type: 'text', value: 'Controlled concentricity in totality to create a high resistance to lateral movements.' }
        ]
      }
    ]
  },
  {
    id: 5,
    name: 'HEX NUTS',
    description: 'Six-sided nuts used with bolts and screws to fasten components.',
    image: '/products/32.jpg',
    mainImage: '/products/hex.png',
    technicalImage: '/products/prd-t5.png',
    specifications: [
      'As per DIN934 & ISO4032 for Metric Series',
      'Range: Metric Series: M3 to M60',
      'M3 to M27 by Cold Forging Process',
      'M27 and Above by Hot Forging Process',
      'Controlled thread profile for maximum strength',
      'Uniform thread depth for accurate fit & higher torque',
      'Smooth fillet radius to withstand soundness',
      'Uniform & uninterrupted grain flow for greater strength',
      'Controlled mechanical properties for higher strength'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Metric Series – DIN934 & ISO4032 | Inch Series – BS:1768, B-18.2 & SAE: J429 (UNC) | BS:1083 (BSF)' },
          { type: 'text', value: 'Grade: 8/10' },
          { type: 'text', value: 'Metric Series – Grade 8: M3 to M12 | Grade 10: M14 to M60' },
          { type: 'text', value: 'Inch Series – Grade 8: 1/4" to 1/2" | Grade 10: 5/8" to 1"' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Structure: Hexagonal Nut' },
          { type: 'text', value: 'Forging: M3 to M27 by Cold Forging Process | M27 and Above by Hot Forging Process' },
          { type: 'text', value: 'Raw Material Used: Gr.8 - 1010/1018' },
          { type: 'text', value: 'Gr.10 - 10B21/15B25 (Cold Forging) | EN8D (Hot Forging)' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'Controlled thread profile for maximum strength.' },
          { type: 'text', value: 'Uniform thread depth for accurate fit & higher torque.' },
          { type: 'text', value: 'Smooth fillet radius to withstand soundness.' },
          { type: 'text', value: 'Uniform & uninterrupted grain flow for greater strength.' },
          { type: 'text', value: 'Controlled mechanical properties for higher strength.' }
        ]
      }
    ]
  },
  {
    id: 6,
    name: 'HEX HEAD BOLT/SCREW',
    description: 'Bolts/screws with a hexagonal head, driven by a wrench.',
    image: '/products/31.jpg',
    mainImage: '/products/hex-h.jpg',
    technicalImage: '/products/prd-t6.png',
    specifications: [
      'Controlled Hexagon for maximum wrenching strength',
      'Smooth fillet radius to withstand head soundness',
      'Formed threads with improved root radius provide greater strength to threads',
      'Uniform & uninterrupted grain flow for greater strength',
      'Controlled mechanical properties for higher strength',
      'High quality steel for good strength & wear resistance'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Bolt – DIN931 & ISO4014 | Screw – DIN933 & ISO4017 | Inch Series – BS:1768 & SAE: J-429' },
          { type: 'text', value: 'Grade: Metric – 8.8/10.9 | Inch – Gr.5/Gr.S, Gr.8' },
          { type: 'text', value: 'Metric Series – Diameter: M3 to M48 | Length: 6mm – 400mm' },
          { type: 'text', value: 'Inch Series – Diameter: 1/4" to 1" (Above 1" on order) | Length: 1/2" to 12"' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Bolt – Hexagonal head, half threaded.' },
          { type: 'text', value: 'Screw – Hexagonal head, fully threaded.' },
          { type: 'text', value: 'Forging: M3 to M27 by Cold Forging Process | M27 and Above by Hot Forging Process' },
          { type: 'text', value: 'Raw Material: M3–M12 – 10B21/15B25 | M14–M24 – 10B21/15B25/10B35 | M27–M30 – EN18 | M30+ – EN19' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'Controlled Hexagon for maximum wrenching strength.' },
          { type: 'text', value: 'Smooth fillet radius to withstand head soundness.' },
          { type: 'text', value: 'Formed threads with improved root radius provide greater strength to threads.' },
          { type: 'text', value: 'Uniform & uninterrupted grain flow for greater strength.' },
          { type: 'text', value: 'Controlled mechanical properties for higher strength.' },
          { type: 'text', value: 'High quality steel for good strength & wear resistance.' }
        ]
      }
    ]
  },
  {
    id: 7,
    name: 'HEXAGON WRENCHES (ALLEN KEYS)',
    description: 'L-shaped tools used to drive bolts and screws with hexagonal sockets.',
    image: '/products/33.jpg',
    mainImage: '/products/key.jpg',
    technicalImage: '/products/prd-t7.png',
    specifications: [
      'Hexagonal Internal Wrenching Tool Suitable for all Socket Screw',
      'As per Din 911, ISO2936, IS 3082, BS 2470',
      'Range - Metric: 1.5mm – 32mm',
      'Range - Inch: 1/16" – 3/4"',
      'High Precision Dimensional Accurate Hexagonal Keys',
      'High Strength and Highly Ductile',
      'Heat Treated to Minim. 47 HRC',
      'Also Available in Sets'
    ],
    pages: [
      {
        pageNumber: 1,
        title: 'Technical Specifications',
        content: [
          { type: 'text', value: 'Standard: Metric Series – DIN911 & ISO2936 | Inch Series – BS2470' },
          { type: 'text', value: 'Metric Series – Range: 1.5mm to 32mm' },
          { type: 'text', value: 'Inch Series – Range: 1/16" to 3/4"' },
          { type: 'text', value: 'Also Available in Sets' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Structural Specifications',
        content: [
          { type: 'text', value: 'Structure: L-shaped hexagonal bar, short arm and long arm.' },
          { type: 'text', value: 'Material: Alloy Steel – Heat Treated to minimum 47 HRC.' },
          { type: 'text', value: 'High Precision Dimensional Accuracy for exact socket fit.' }
        ]
      },
      {
        pageNumber: 3,
        title: 'General Features',
        content: [
          { type: 'text', value: 'Hexagonal Internal Wrenching Tool suitable for all socket screws.' },
          { type: 'text', value: 'High Strength and Highly Ductile.' },
          { type: 'text', value: 'Heat Treated to minimum 47 HRC for long service life.' },
          { type: 'text', value: 'High Precision Dimensional Accurate Hexagonal Keys.' },
          { type: 'text', value: 'Available individually and in complete sets.' }
        ]
      }
    ]
  },
  {
    id: 8,
    name: 'SPECIAL FASTENERS',
    description: 'Custom-engineered fasteners designed for specific applications.',
    image: '/products/special-fasteners-new.png',
    specifications: [],
    pages: [
      {
        pageNumber: 1,
        title: 'Connecting Rod Bolt',
        image: '/products/connecting_rod_bolt2.png',
        content: [
          { type: 'text', value: 'Grade: 8.8 / 10.9 / 12.9  |  Standard: ISO 898-1' },
          { type: 'text', value: 'Fine pitch rolled thread with a precision shank and controlled under-head radius for engine connecting rod applications.' }
        ]
      },
      {
        pageNumber: 2,
        title: 'Wheel Bolt',
        image: '/products/wheel_bolt2.png',
        content: [
          { type: 'text', value: 'Grade: 10.9  |  Standard: DIN 74361' },
          { type: 'text', value: 'Hexagonal head with conical (60°) or spherical seat for wheel centering; plain shank designed to carry shear load and provide secure clamping.' }
        ]
      },
      {
        pageNumber: 3,
        title: 'Stud',
        image: '/products/stud.png',
        content: [
          { type: 'text', value: 'Grade: 10.9  |  Standard: DIN 938 / DIN 939' },
          { type: 'text', value: 'Headless fastener with external threads on both ends and a plain central shank for double-sided fastening applications.' }
        ]
      },
      {
        pageNumber: 4,
        title: 'Flange Bolt',
        image: '/products/flange.png',
        content: [
          { type: 'text', value: 'Grade: 8.8 / 10.9  |  Standard: DIN 6921' },
          { type: 'text', value: 'Hexagonal head bolt with an integral circular flange under the head, distributing clamping load over a larger bearing surface.' }
        ]
      },
      {
        pageNumber: 5,
        title: 'Dowel Pin',
        image: '/products/dowel_pin.png',
        content: [
          { type: 'text', value: 'Grade: Hardened  |  Standard: ISO 8734 (DIN 6325)' },
          { type: 'text', value: 'Precision cylindrical solid pin with chamfered ends, used for accurate alignment and location of mating components.' }
        ]
      },
      {
        pageNumber: 6,
        title: 'Track Shoe Bolt',
        image: '/products/track_shoe_bolt.png',
        content: [
          { type: 'text', value: 'Grade: 10.9 / 12.9  |  Standard: DIN 864' },
          { type: 'text', value: 'Low-profile oval head bolt with nibs under the head to lock into the track shoe and prevent rotation during assembly.' }
        ]
      },
      {
        pageNumber: 7,
        title: 'Tooth Bolt',
        image: '/products/tooth_bolt2.png',
        content: [
          { type: 'text', value: 'Grade: 10.9  |  Standard: DIN 608' },
          { type: 'text', value: 'Plow head (flat countersunk) bolt with a square neck beneath the head to prevent rotation, for agricultural and earthmoving equipment.' }
        ]
      },
      {
        pageNumber: 8,
        title: 'Shoulder Bolt',
        image: '/products/shoulder_bolt2.png',
        content: [
          { type: 'text', value: 'Grade: 10.9 / 12.9  |  Standard: ISO 7379 (DIN 7379)' },
          { type: 'text', value: 'Precision ground cylindrical shoulder (unthreaded shank) under the head with a short metric threaded end for pivot and locating applications.' }
        ]
      },
      {
        pageNumber: 9,
        title: 'Axle',
        image: '/products/axle2.png',
        content: [
          { type: 'text', value: 'Grade: 10.9 / 12.9  |  Standard: As per drawing' },
          { type: 'text', value: 'Solid or hollow cylindrical shaft with precision-machined ends for bearing and wheel mounting; may include splines, keyways, or threaded portions.' }
        ]
      },
      {
        pageNumber: 10,
        title: 'Torx Screw',
        image: '/products/torx_screw2.png',
        content: [
          { type: 'text', value: 'Grade: 8.8 / 10.9 / 12.9  |  Standard: ISO 14579 / DIN 7985' },
          { type: 'text', value: 'Pan or button head screw with a Torx (star) drive recess, offering higher torque transmission and reduced cam-out compared to hex drives.' }
        ]
      }
    ]
  }
]; 